import { translitToRus } from 'app/utils';
import { createSelector } from 'reselect';
const driverState = (state) => state.driver;

export const itemsSelector = createSelector(driverState, (driver) => driver.items);
export const searchValueSelector = createSelector(driverState, (driver) => driver.searchValue);
export const selectedItemSelector = createSelector(driverState, (driver) => driver.selectedItem);

export const sortItemsSelector = createSelector([itemsSelector, searchValueSelector], (items, searchValue) => {
    const compareFn = (a, b) => a.name.localeCompare(b.name, { sensitivity: 'base' });

    if (searchValue.length) {
        return items.filter((item) => translitToRus(item.name).indexOf(translitToRus(searchValue)) !== -1).sort(compareFn);
    }

    return items.sort(compareFn);
});
